/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getAllergyLegends } from 'app/entities/allergy-legend/allergy-legend.reducer';
import { getEntities as getAllergySymptoms } from 'app/entities/allergy-symptom/allergy-symptom.reducer';
import { createEntity, getEntity, reset, updateEntity } from './user-allergies.reducer';

export const UserAllergiesUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const allergyLegends = useAppSelector(state => state.allergyLegend.entities);
  const allergySymptoms = useAppSelector(state => state.allergySymptom.entities);
  const userAllergiesEntity = useAppSelector(state => state.userAllergies.entity);
  const loading = useAppSelector(state => state.userAllergies.loading);
  const updating = useAppSelector(state => state.userAllergies.updating);
  const updateSuccess = useAppSelector(state => state.userAllergies.updateSuccess);

  const handleClose = () => {
    navigate(`/user-allergies${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getGlucoUsers({}));
    dispatch(getAllergyLegends({}));
    dispatch(getAllergySymptoms({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.startDate !== undefined && typeof values.startDate !== 'number') {
      values.startDate = Number(values.startDate);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...userAllergiesEntity,
      ...values,
      glucoUser: glucoUsers.find(it => it.id.toString() === values.glucoUser?.toString()),
      allergy: allergyLegends.find(it => it.id.toString() === values.allergy?.toString()),
      sympton: allergySymptoms.find(it => it.id.toString() === values.sympton?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...userAllergiesEntity,
          glucoUser: userAllergiesEntity?.glucoUser?.id,
          allergy: userAllergiesEntity?.allergy?.id,
          sympton: userAllergiesEntity?.sympton?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.userAllergies.home.createOrEditLabel" data-cy="UserAllergiesCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.userAllergies.home.createOrEditLabel">Create or edit a UserAllergies</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="user-allergies-id"
                  label={translate('tinyMedicRestApp.userAllergies.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.userAllergies.active')}
                id="user-allergies-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAllergies.endDate')}
                id="user-allergies-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAllergies.microSec')}
                id="user-allergies-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAllergies.startDate')}
                id="user-allergies-startDate"
                name="startDate"
                data-cy="startDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAllergies.timestampentry')}
                id="user-allergies-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAllergies.lastupdated')}
                id="user-allergies-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.userAllergies.cursor')}
                id="user-allergies-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="user-allergies-glucoUser"
                name="glucoUser"
                data-cy="glucoUser"
                label={translate('tinyMedicRestApp.userAllergies.glucoUser')}
                type="select"
                required
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="user-allergies-allergy"
                name="allergy"
                data-cy="allergy"
                label={translate('tinyMedicRestApp.userAllergies.allergy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {allergyLegends
                  ? allergyLegends.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="user-allergies-sympton"
                name="sympton"
                data-cy="sympton"
                label={translate('tinyMedicRestApp.userAllergies.sympton')}
                type="select"
                required
              >
                <option value="" key="0" />
                {allergySymptoms
                  ? allergySymptoms.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/user-allergies" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default UserAllergiesUpdate;
